import { http } from "../../services/api.services";

export const BoxService = {
  getBoxTypes: () => http.get("/box-types")
}